import { CommonModule, NgTemplateOutlet } from "@angular/common";
import { Component, Input, OnInit, TemplateRef, ViewEncapsulation } from "@angular/core";
import { Size, SIZE_CONFIG } from "./corp-card.constant";

@Component({
    selector     : 'corp-card',
    templateUrl  : './corp-card.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [CommonModule, NgTemplateOutlet ],
    providers: [  ],
})
export class CorpCardComponent implements OnInit
{
    @Input('corp-label') corpLabel: string | null = null;
    @Input('corp-content') corpContent: TemplateRef<any> | null = null;
    @Input('corp-context') corpContext: any | null = null;
    @Input('corp-icon') corpIcon: string | null = null;
    @Input('corp-image') corpImage: string | null = null;
    @Input('corp-size') corpSize: Size = 'md'

    /**
     * Constructor
     */
    constructor() { }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void { }

    get sizeClasses() {
        return SIZE_CONFIG[this.corpSize];
    }

}
